import React from 'react'

const ErrorMessage = ({
  text,
  fontWeight
}) => {
  return (
    <div className='error-message' style={{
      fontWeight: fontWeight || '500'
    }}>{text}</div>
  )
}

export default ErrorMessage